import React from 'react';

const NoBillingAddressFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/please-add-your-billing-details.png"} width="300" />
    </div>;
}

export default NoBillingAddressFound;